import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { Button } from 'primeng/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'transport-expandable-info-text',
  imports: [Button, TranslatePipe],
  templateUrl: './expandable-info-text.component.html',
  styleUrl: './expandable-info-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableInfoTextComponent {
  public readonly shortText = input.required<string>();
  public readonly longText = input.required<string>();

  protected readonly showFullText = signal<boolean>(false);

  protected expandText() {
    this.showFullText.set(true);
  }
}
